const ProductActionTypes = {
    ALL_PRODUCTS_LIST: "ALL_PRODUCTS_LIST",
    CATEGORY_PRODUCTS_LIST: "CATEGORY_PRODUCTS_LIST",
    PRODUCT_DETAILS: "PRODUCT_DETAILS",
  };
  
  export default ProductActionTypes;
  